import React, { useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as PR from "../../prime-modules/index";
import { Link } from 'react-router-dom';
import Input from "../../components/input";
import { useMutation } from "react-query";
import { afLogin } from "../../services/affiliateApi";
import { siginValidationSchema } from "../../utils/schema";
import { useDispatch, useSelector } from "react-redux";
import { afLoginReducer } from "../../store/afAuth.slice";
import Layout from "../../components/layout/Layout";
import TwoFactorAuthentication from "../two-factor-authentication";
import { globalConfig } from "../../constants";

const AffiliateSignin = () => {
  const appName = process.env.REACT_APP_NAME;
  const isCorporate = appName?.includes("corporate");
  const { affiliate } = useSelector(state => state.language?.activelang);
    const dispatch = useDispatch();
    const toast = useRef();
    const [loginResponse, setLoginResponse] = useState(undefined)
    const {mutate, isLoading} = useMutation(afLogin,{
      onSuccess:response=>{
        if(response?.otpEnabled){
          setLoginResponse(response)
          return
      }
        dispatch(afLoginReducer(response)
      );},
      onError: o => {
        toast.current.show({ life:globalConfig?.errorToastDisplayTime, severity:"error",summary: 'Error', detail:o.message })
      }
    });

    return (
      <>
      <Layout>  
      <Formik
  initialValues={{ email: "", password: "" }}
  onSubmit={mutate}
  validationSchema={siginValidationSchema}
>
  {({ values }) => (
    <>
      <PR.Toast ref={toast} />

      {!loginResponse ? (
        <section className="signup-section">
          <div className="grid">
            <div className="col-12 text-center">
              <h1>{isCorporate ? affiliate?.AFFNL0145 : affiliate?.AFFNL0043}</h1>
              <p>{affiliate?.AFFNL0044}</p>
              <div className="signup-wrapper">
                <Form autoComplete="off" className="form-block">
                  <div className="grid">
                    <div className="col-12 md:col-12">
                      <Input
                        label={affiliate?.AFFNL0006}
                        name={"email"}
                        type={"email"}
                        aria-describedby={"email"}
                        placeholder={affiliate?.AFFNL0032}
                      />
                    </div>
                    <div className="col-12 md:col-12">
                      <Input
                        feedback={false}
                        label={affiliate?.AFFNL0016}
                        aria-describedby={"password"}
                        toggleMask
                        placeholder={affiliate?.AFFNL0040}
                        name={"password"}
                        type={"password"}
                      />
                      <p className="text-right forgot-pass-p">
                        <Link to="/forgot-password">{affiliate?.AFFNL0005}</Link>
                      </p>
                    </div>
                    <div className="col-12 pb-0">
                      <PR.Button
                        label={affiliate?.AFFNL0014}
                        type="submit"
                        className="signup-button w-12"
                        disabled={isLoading}
                        icon={isLoading && "pi pi-spin pi-spinner"}
                      />
                    </div>
                  </div>
                  <p className="link-p">
                    {affiliate?.AFFNL0015}{" "}
                    <Link to="/affiliate-signup">{affiliate?.AFFNL0038}</Link>
                  </p>
                </Form>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <TwoFactorAuthentication
          loginResponse={loginResponse}
          email={values.email}
          password={values.password}
          loginMutate={mutate}
          toast={toast}
        />
      )}
    </>
  )}
</Formik>

        </Layout>
      </>
    );
};

export default AffiliateSignin;
